import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import UserModal from "../components/UserModal";
import api from "../services/api";

import {
    FaPlus,
    FaEdit,
    FaTrash,
    FaSearch,
    FaEye
} from "react-icons/fa";

import { toast } from "react-toastify";
import DeleteConfirmModal from "../components/DeleteConfirmModal";

const UserList = () => {

    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);

    const [search, setSearch] = useState("");

    const [showModal, setShowModal] = useState(false);

    const [selectedUser, setSelectedUser] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const [deleteId, setDeleteId] = useState(null);
    const loadUsers = async () => {

        try {

            setLoading(true);

            const res = await api.get("/users");

            setUsers(res.data.data);

        } catch (error) {

            toast.error("Unable to load users");

        } finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        loadUsers();

    }, []);

    const addUser = () => {

        setSelectedUser(null);

        setShowModal(true);

    };

    const editUser = (user) => {

        setSelectedUser(user);

        setShowModal(true);

    };

    const deleteUser = async () => {

        try {

            await api.delete(`/users/${deleteId}`);

            toast.success("User Deleted Successfully");

            setShowDeleteModal(false);
            setDeleteId(null);

            loadUsers();

        } catch (error) {

            toast.error(
                error.response?.data?.message ||
                "Unable to delete user"
            );

            setShowDeleteModal(false);

        }

    };
    const filteredUsers = users.filter((user) => {

        return (

            user.username
                .toLowerCase()
                .includes(search.toLowerCase()) ||

            user.shop_name
                .toLowerCase()
                .includes(search.toLowerCase()) ||

            user.person_name
                .toLowerCase()
                .includes(search.toLowerCase()) ||

            user.mobile_no
                .includes(search)

        );

    });
    return (

        <>




            <Navbar />

            <div className="container mt-4">

                <div className="card shadow">

                    <div className="card-header bg-primary text-white">

                        <div className="d-flex justify-content-between align-items-center">

                            <h4>User Management</h4>

                            <button
                                className="btn btn-light"
                                onClick={addUser}
                            >

                                <FaPlus />

                                &nbsp;

                                Add User

                            </button>

                        </div>

                    </div>
                    <div className="card-body">

                        <div className="row mb-3">

                            <div className="col-md-4">

                                <div className="input-group">

                                    <span className="input-group-text">

                                        <FaSearch />

                                    </span>

                                    <input

                                        className="form-control"

                                        placeholder="Search User..."

                                        value={search}

                                        onChange={(e) =>

                                            setSearch(e.target.value)

                                        }

                                    />

                                </div>

                            </div>

                        </div>
                        <table className="table table-bordered table-hover">

                            <thead className="table-dark">

                                <tr>

                                    <th>ID</th>

                                    <th>Username</th>

                                    <th>Shop Name</th>

                                    <th>Person Name</th>

                                    <th>Mobile</th>

                                    <th>Role</th>

                                    <th>Created</th>

                                    <th width="220">

                                        Action

                                    </th>

                                </tr>

                            </thead>

                            <tbody>{
                                loading ?

                                    <tr>

                                        <td
                                            colSpan="8"
                                            className="text-center"
                                        >

                                            Loading...

                                        </td>

                                    </tr> :

                                    filteredUsers.length === 0 ?

                                        <tr>

                                            <td
                                                colSpan="8"
                                                className="text-center"
                                            >

                                                No Users Found

                                            </td>

                                        </tr> :

                                        filteredUsers.map((user) => (

                                            <tr key={user.id}>

                                                <td>{user.id}</td>

                                                <td>{user.username}</td>

                                                <td>{user.shop_name}</td>

                                                <td>{user.person_name}</td>

                                                <td>{user.mobile_no}</td>

                                                <td>

                                                    <span className={
                                                        user.role === "admin"
                                                            ?

                                                            "badge bg-danger"

                                                            :

                                                            "badge bg-success"

                                                    }>

                                                        {user.role}

                                                    </span>

                                                </td>

                                                <td>

                                                    {new Date(user.created_at).toLocaleDateString()}

                                                </td>

                                                <td>

                                                    <button

                                                        className="btn btn-success btn-sm me-2"
                                                        title="View Scan Details"
                                                        onClick={() =>
                                                            navigate(`/user-scans/${user.username}`)
                                                        }

                                                    >

                                                        <FaEye />

                                                    </button>

                                                    <button

                                                        className="btn btn-warning btn-sm me-2"

                                                        onClick={() => editUser(user)}

                                                    >

                                                        <FaEdit />

                                                    </button>

                                                    <button

                                                        className="btn btn-danger btn-sm"

                                                        onClick={() => {

                                                            setDeleteId(user.id);

                                                            setShowDeleteModal(true);

                                                        }}

                                                    >

                                                        <FaTrash />

                                                    </button>

                                                </td>

                                            </tr>

                                        ))
                            }
                            </tbody>

                        </table>

                    </div>

                </div>

            </div>

            <UserModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                selectedUser={selectedUser}
                loadUsers={loadUsers}
            />
            <DeleteConfirmModal
                show={showDeleteModal}
                title="Delete User"
                message="Are you sure you want to delete this user?"
                onClose={() => {
                    setShowDeleteModal(false);
                    setDeleteId(null);
                }}
                onConfirm={deleteUser}
            />
        </>

    );

};

export default UserList;